import { render } from "./MainHeader.vue?vue&type=template&id=59ef3593&ts=true"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__